import { styled } from '@mui/material';
import { up } from '../../../../../theme';

export const classes = {
  root: 'root',
  mainGrid: 'mainGrid',
  innerGrid: 'innerGrid',
  logoBox: 'logoBox',
  formMainBox: 'formMainBox',
  formMainFormControl: 'formMainFormControl',
  formAllTextFields: 'formAllTextFields',
  eyeIconForPassword: 'eyeIconForPassword',
  submitButton: 'submitButton',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.mainGrid}`]: {
    height: '100vh',
    justifyContent: 'center',
    background: theme.palette.darkPurple.main,
  },

  [`& .${classes.innerGrid}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },

  [`& .${classes.logoBox}`]: {
    [up('xs')]: {
      width: '48px',
    },
    [up('sm')]: {
      width: '68px',
    },
    [up('md')]: {
      width: '88px',
    },
    [up('lg')]: {
      width: '108px',
    },
    [up('xl')]: {
      width: '128px',
    },
    [up('xxl')]: {
      width: '148px',
    },
  },

  [`& .${classes.formMainBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '75vh',
    width: '100%',
    overflow: 'auto',
    borderRadius: '10px',
    backgroundColor: theme.palette.secondaryWhite.main,
    boxShadow: `0px 2px 8px ${theme.palette.secondaryBlack.lighter}`,
    '&::-webkit-scrollbar': {
      width: '10px',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-track': {
      background: `${theme.palette.lynxWhite.main}`,
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: `${theme.palette.secondaryBlack.lighter}`,
      borderRadius: '5px',
    },
  },

  [`& .${classes.formMainFormControl}`]: {
    display: 'flex',
    flexDirection: 'column',
    width: '67.5%',
    padding: '8.5vh 0',
  },

  [`& .${classes.formAllTextFields}`]: {
    marginBottom: '30px',
    width: '100%',
  },

  [`& .${classes.eyeIconForPassword}`]: {
    filter: 'brightness(98%) contrast(60%) sepia(10%)',
    [up('xs')]: {
      height: '10px',
      width: '10px',
    },
    [up('sm')]: {
      height: '10px',
      width: '10px',
    },
    [up('md')]: {
      height: '12px',
      width: '12px',
    },
    [up('lg')]: {
      height: '14px',
      width: '14px',
    },
    [up('xl')]: {
      height: '16px',
      width: '16px',
    },
    [up('xxl')]: {
      height: '18px',
      width: '18px',
    },
  },

  [`& .${classes.submitButton}`]: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.darker,
    },
    [up('xs')]: {
      height: '44px',
    },
    [up('lg')]: {
      height: '50px',
    },
  },
}));
